import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateEventTimingStatus} from '../event-timing-status/index.js';
import {generateMiniScoreboard} from '../mini-scoreboard/index.js';
import {generateParticipants} from '../participants/index.js';

import MINI_EVENT_ITEM from './mini-event-item.palette-schema.yaml';
import MINI_EVENT_ITEM_CONTENT from './mini-event-item-content.palette-schema.yaml';

registerTileSchema(MINI_EVENT_ITEM_CONTENT);
registerTileSchema(MINI_EVENT_ITEM);

export function generateMiniEventItem(TILE) {
    return {
        container: {
            style: {
                base: {
                    ...resolveBackground(TILE.MINI_EVENT_ITEM_BG),
                    boxSizing: 'content-box',
                },
                active: {
                    ...resolveBackground(TILE.MINI_EVENT_ITEM_SELECTED_BG),
                },
            },
        },
        detailsContainer: {
            style: {
                overflow: 'visible',
            },
        },
        content: constructMiniEventItemContent(TILE.MINI_EVENT_ITEM_CONTENT),
        contentActive: constructMiniEventItemContent(TILE.MINI_EVENT_ITEM_SELECTED_CONTENT),
    };
}

function constructMiniEventItemContent(TILE) {
    const {FONT} = TILE;

    return {
        eventTimingStatus: generateEventTimingStatus(TILE.MINI_EVENT_ITEM_TIMING_STATUS),
        scoreboard: generateMiniScoreboard(TILE.MINI_EVENT_ITEM_SCOREBOARD),
        eventNameLabel: {
            style: {
                fontSize: FONT.SIZE_MEDIUM,
                fontWeight: FONT.WEIGHT_BOLD,
                ...TILE.MINI_EVENT_ITEM_PARTICIPANTS.PARTICIPANTS_TEXT,
            },
        },
        participants: generateParticipants(TILE.MINI_EVENT_ITEM_PARTICIPANTS),
        icon: icon(TILE.MINI_EVENT_ITEM_CHEVRON_ICON_COLOR),
    };
}
